import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";
import {rpAppLink} from "@pg-mono/rp-routes";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../../types/AuthActionType";
import {RegisterForm} from "./RegisterForm";
import {SocialAuth} from "./SocialAuth";
import {UserDataAdministrator} from "./UserDataAdministrator";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    description?: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

export const RegisterCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, description, gtmEventData, wrapperClassName} = props;

    const handleRegisterSuccess = () => {
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    return (
        <div className={cx(card, wrapperClassName)}>
            <Text align="center" variant="headline_6" className={css({marginBottom: 3})}>
                {title}
            </Text>

            {description && (
                <Text align="center" as="p" className={css({marginBottom: 4})} color={theme.colors.gray[700]} variant="body_copy_2">
                    {description}
                </Text>
            )}

            <RegisterForm onSuccessfulSubmit={handleRegisterSuccess} gtmEventData={gtmEventData} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <Text align="center" as="div" variant="info_txt_2" className={dividerTextStyle}>
                Lub
            </Text>

            <SocialAuth onAuthSuccess={onAuthSuccess} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <div className={signIn}>
                <Text variant="info_txt_1">Masz już konto?</Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary">
                    Zaloguj się
                </Button>
            </div>

            <UserDataAdministrator />

            <Text className={css({marginTop: 0.5})} variant="info_txt_2" align="center">
                Akceptuję{" "}
                <Link href={rpAppLink.termsOfService.base()} target="_blank" size="inherit" underline>
                    regulamin serwisu
                </Link>
            </Text>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    paddingY: 3,
    paddingX: 2
});

const signIn = css({
    borderTop: "1px solid var(--colors-gray-200)",
    paddingTop: 3,
    marginBottom: 3,
    marginTop: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 1.5
});

const dividerTextStyle = css({
    marginTop: 3,
    marginBottom: 1.5
});
import {ReactNode} from "react";
import {css, cx} from "@panda/css";

import {Button} from "@pg-design/button-module";
import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {themeRP as theme} from "@pg-design/themes";
import {rpAppLink} from "@pg-mono/rp-routes";

import {UserSource} from "../../../tracking/tracking_utils/user_source";
import {AuthActionType} from "../../types/AuthActionType";
import {RegisterForm} from "./RegisterForm";
import {SocialAuth} from "./SocialAuth";
import {UserDataAdministrator} from "./UserDataAdministrator";

interface IProps {
    onAuthSuccess: (authActionType: AuthActionType) => void;
    onSwitchToLogin: () => void;
    userSource: UserSource;
    gtmSourceSection?: string;
    title: ReactNode | string;
    description?: ReactNode | string;
    gtmEventData?: () => void;
    wrapperClassName?: string;
}

export const RegisterCard = (props: IProps) => {
    const {onAuthSuccess, onSwitchToLogin, userSource, gtmSourceSection, title, description, gtmEventData, wrapperClassName} = props;

    const handleRegisterSuccess = () => {
        onAuthSuccess(AuthActionType.REGISTRATION);
    };

    return (
        <div className={cx(card, wrapperClassName)}>
            <Text align="center" variant="headline_6" className={css({marginBottom: 3})}>
                {title}
            </Text>

            {description && (
                <Text align="center" as="p" className={css({marginBottom: 4})} color={theme.colors.gray[700]} variant="body_copy_2">
                    {description}
                </Text>
            )}

            <RegisterForm onSuccessfulSubmit={handleRegisterSuccess} gtmEventData={gtmEventData} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <Text align="center" as="div" variant="info_txt_2" className={dividerTextStyle}>
                Lub
            </Text>

            <SocialAuth onAuthSuccess={onAuthSuccess} userSource={userSource} gtmSourceSection={gtmSourceSection} />

            <div className={signIn}>
                <Text variant="info_txt_1">Masz już konto?</Text>

                <Button onClick={onSwitchToLogin} variant="highlight_primary">
                    Zaloguj się
                </Button>
            </div>

            <UserDataAdministrator />

            <Text className={css({marginTop: 0.5})} variant="info_txt_2" align="center">
                Akceptuję{" "}
                <Link href={rpAppLink.termsOfService.base()} target="_blank" size="inherit" underline>
                    regulamin serwisu
                </Link>
            </Text>
        </div>
    );
};

const card = css({
    width: "100%",
    backgroundColor: "#fff",
    paddingY: 3,
    paddingX: 2
});

const signIn = css({
    borderTop: "1px solid var(--colors-gray-200)",
    paddingTop: 3,
    marginBottom: 3,
    marginTop: 2,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    rowGap: 1.5
});

const dividerTextStyle = css({
    marginTop: 3,
    marginBottom: 1.5
});
